import React from 'react'
import {Text, View} from '@react-pdf/renderer'
import {Title} from './common'
import styles from './styles'
import fieldTypes from './field-content'
import {isFieldEmpty} from '../../../helpers/utils'

export default function Field (props) {
  const { id, name, context } = props
  const className = props.className.replace('-','')

  const sections = props.sections
    .map((props, contentId) => ({props, Element: fieldTypes[props.type], contentId}))
    .filter(({Element, props}) => Element && !isFieldEmpty(props))
    .map(({Element, props, contentId}, index) => (<Element key={index} index={index} className={className} {...props} id={id} contentId={contentId} context={context} />))

  return (<React.Fragment>
    {sections.length > 0 && (
    <View wrap={false}>
      <Title style={[styles[className]]} title={name} />
      <View style={[styles[`${className}Field`],styles.field]}>
        {sections}
      </View>
    </View>)}
  </React.Fragment>)
}
